<template>
  <div class="main-content">
    <b-container class="pb-5">
      <b-row class="mt-5">
        <b-col lg="6" offset-lg="3">
          <h1>Accedi all'Area Riservata</h1>
          <p class="text-secondary">
            Inserisci il tuo nome utente e password e premi su accedi.
          </p>
          <b-form v-on:submit.prevent="checkAuth">
            <b-form-group label="Username">
              <b-form-input
                type="text"
                v-model="login.username"
                label="Username"
                required
                placeholder="Inserisci username"
                v-validate="'required'"
                data-vv-name="username"
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="Password">
              <b-form-input
                type="password"
                v-model="login.password"
                label="Password"
                required
                placeholder="Inserisci password"
                v-validate="'required'"
                data-vv-name="username"
              >
              </b-form-input>
            </b-form-group>
            <hr />
            <b-form-group>
              <b-button
                size="lg"
                type="submit"
                variant="primary"
                class="mr-2"
                :disabled="!formFilled"
                >Accedi</b-button
              >
              <b-button
                size="lg"
                type="button"
                variant="outline-danger"
                :to="'recover'"
                >Recupera password</b-button
              >
            </b-form-group>
          </b-form>
          <b-alert variant="danger" show v-if="error" class="mt-3"
            >Attenzione! {{ error }}</b-alert
          >
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      login: {
        username: null,
        password: null
      },
      e1: true,
      error: null
    };
  },
  computed: {
    formFilled() {
      return this.login.username && this.login.password;
    }
  },
  mounted() {
    return this.initData();
  },

  methods: {
    async initData() {
      await this.$apiclient.getLoginData();
    },
    checkAuth() {
      this.$validator.validateAll();

      if (!this.errors.any()) {
        const credentials = {
          ...this.login
        };

        let loader = this.$loading.show();
        this.$store
          .dispatch("loginByUsernamePassword", credentials)
          .then(() => {
            console.log("Logged with success");
            loader.hide();
            this.$router.push("/area-riservata/piani");
          })
          .catch(err => {
            console.log("Wrong credentials..", err);
            loader.hide();
            this.error = "Nome utente o password errate.";
          });
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/Login.vue